import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";

import InfoButton from "../../../components/buttons/InfoButton";
import DossierBudgetsChart from "../../../components/charts/APCharts/dossierBudgets/DossierBudgetsChart";
import DossierSelector from "../../../components/dossier/DossierSelector";
import PageContainer from "../../../components/PageContainer";
import { isDossierActive } from "../../../helpers/dossiers";
import { useDossierActivationCheck } from "../../../hooks/useDossierActivationCheck";
import { useFaqs } from "../../../hooks/useFaqs";
import ActiveDossierNavButtons from "../components/ActiveDossierNavButtons";

const ViewDossierBudgets = () => {
  const { dossierId } = useParams<{
    dossierId: string;
  }>();

  const {
    navigationCheckComplete,
    isLoading: isLoadingDossierActivation,
    isSuccess: isSuccessDossierActivation,
    activatedDossiers,
  } = useDossierActivationCheck({
    dossierId,
  });
  const selectedDossier = activatedDossiers.find(
    (dossier) => dossier.id === dossierId
  );
  const {
    faqProps,
    isSuccess: isSuccessFaqs,
    isLoading: isLoadingFaqs,
  } = useFaqs({
    pageId: "dossier-budgets-view",
    contextIds: {
      opportunityId: selectedDossier?.opportunity?.id,
    },
  });
  const isLoading = isLoadingFaqs || isLoadingDossierActivation;
  const isSuccess = isSuccessFaqs && isSuccessDossierActivation;

  return (
    <PageContainer
      title="Available Budget"
      titleButton={
        <Box>
          {faqProps.renderAppLocation(
            "DossierBudget-Page",
            <InfoButton />,
            true,
            true
          )}
        </Box>
      }
      loading={isLoading || !navigationCheckComplete}
    >
      {isSuccess && navigationCheckComplete && selectedDossier && (
        <Stack spacing={2}>
          {selectedDossier && (
            <DossierSelector
              dossiers={activatedDossiers}
              selectedDossier={selectedDossier}
              redirectTo="dossierBudgets"
              showDivider
            />
          )}
          <Box pt={1}>
            <DossierBudgetsChart
              dossierId={selectedDossier.id}
              showTotals
              faqs={faqProps}
              faqAppLocationIdentifiers={{
                category: "DossierBudget-BudgetCategory",
                availableBudget: "DossierBudget-AvailableBudget",
              }}
            />
            <Box pt={2}>
              <Typography variant="labelSmall">
                Note: all values are Ex GST
              </Typography>
            </Box>
          </Box>
          <ActiveDossierNavButtons
            dossier={selectedDossier}
            backTypes={["back", "home"]}
            navButtons={["view-balances", "view-transactions"]}
            rightNavButtons={
              isDossierActive(selectedDossier) ? ["submit-claim"] : undefined
            }
          />
        </Stack>
      )}
    </PageContainer>
  );
};

export default ViewDossierBudgets;
